// extracted by mini-css-extract-plugin
module.exports = {"collapse":"styles_collapse__xQ_Jw","collapsedRow":"styles_collapsedRow__kEqZI","a":"styles_a__P6tSB"};